import { useAppSelector } from 'applications/GSP/shared/hooks/store';

export const useStudent = () => useAppSelector(({ student }) => student);
